(function () {
  'use strict';

  if (window.__cartUpsellAbInitialized) return;
  window.__cartUpsellAbInitialized = true;

  var HOST_SELECTORS = [
    '.rebuy-cart__flyout-body',
    'cart-drawer .cart-drawer__inner',
    '.cart-drawer__inner',
    '#rebuy-cart'
  ];

  var CART_MUTATION_URLS = [
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear'
  ];

  var lastCart = null;

  function getRoot() {
    return document.querySelector('[data-cart-upsell-ab]');
  }

  function getCards() {
    var root = getRoot();
    var inDoc = document.querySelectorAll('[data-cart-upsell-card]');
    if (inDoc.length) return Array.prototype.slice.call(inDoc);
    return root ? Array.prototype.slice.call(root.querySelectorAll('[data-cart-upsell-card]')) : [];
  }

  function findHost() {
    for (var i = 0; i < HOST_SELECTORS.length; i++) {
      var el = document.querySelector(HOST_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function mountCards() {
    var host = findHost();
    if (!host) return;
    getCards().forEach(function (card) {
      if (card.parentElement !== host) host.appendChild(card);
    });
  }

  function evaluate(cart) {
    if (!cart) return;
    var items = cart.items || [];
    var productIds = {};
    var variantIds = {};
    items.forEach(function (item) {
      if (item && item.product_id != null) productIds[String(item.product_id)] = true;
      if (item && item.variant_id != null) variantIds[String(item.variant_id)] = true;
      if (item && item.id != null) variantIds[String(item.id)] = true;
    });

    getCards().forEach(function (card) {
      var triggerId = card.getAttribute('data-trigger-product-id');
      var upsellProductId = card.getAttribute('data-upsell-product-id');
      var upsellVariantId = card.getAttribute('data-upsell-variant-id');

      var triggered = !!productIds[triggerId];
      var alreadyInCart = !!productIds[upsellProductId] || !!variantIds[upsellVariantId];

      if (triggered && !alreadyInCart) {
        showCard(card);
      } else {
        hideCard(card);
      }
    });
  }

  function showCard(card) {
    if (!card.hasAttribute('hidden')) return;
    card.removeAttribute('hidden');
    card.setAttribute('aria-hidden', 'false');
  }

  function hideCard(card) {
    if (card.hasAttribute('hidden')) return;
    card.setAttribute('hidden', '');
    card.setAttribute('aria-hidden', 'true');
  }

  function setLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.setAttribute('disabled', '');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
    }
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        lastCart = cart;
        return cart;
      });
  }

  function refresh() {
    return fetchCart().then(function (cart) {
      mountCards();
      evaluate(cart);
      return cart;
    }).catch(function (error) {
      console.error('[cart-upsell-ab]', error);
    });
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (body) {
        throw new Error(body.description || 'Add to cart failed: ' + response.status);
      });
      return response.json();
    });
  }

  function onAddClick(event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    setLoading(button, true);
    addToCart(variantId)
      .then(function () { return refresh(); })
      .catch(function (error) { console.error('[cart-upsell-ab]', error); })
      .then(function () { setLoading(button, false); });
  }

  function urlMatchesCartMutation(url) {
    if (!url) return false;
    var pathname;
    try {
      pathname = new URL(url, window.location.origin).pathname;
    } catch (e) {
      pathname = String(url);
    }
    return CART_MUTATION_URLS.some(function (prefix) {
      return pathname.indexOf(prefix) === 0;
    });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__cartUpsellAbPatched) return;
    var originalFetch = window.fetch;
    var patched = function () {
      var args = arguments;
      var url = args[0];
      if (url && url.url) url = url.url;
      var isMutation = urlMatchesCartMutation(url);
      var promise = originalFetch.apply(this, args);
      if (isMutation) {
        promise.then(function () { setTimeout(refresh, 0); }, function () {});
      }
      return promise;
    };
    patched.__cartUpsellAbPatched = true;
    window.fetch = patched;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest) return;
    var Xhr = window.XMLHttpRequest;
    if (Xhr.prototype.__cartUpsellAbPatched) return;
    var open = Xhr.prototype.open;
    var send = Xhr.prototype.send;
    Xhr.prototype.open = function (method, url) {
      this.__cartUpsellAbUrl = url;
      return open.apply(this, arguments);
    };
    Xhr.prototype.send = function () {
      if (urlMatchesCartMutation(this.__cartUpsellAbUrl)) {
        this.addEventListener('loadend', function () { setTimeout(refresh, 0); });
      }
      return send.apply(this, arguments);
    };
    Xhr.prototype.__cartUpsellAbPatched = true;
  }

  function watchDom() {
    if (!window.MutationObserver) return;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        mountCards();
        if (lastCart) evaluate(lastCart);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!getRoot()) return;

    document.addEventListener('click', onAddClick);

    patchFetch();
    patchXhr();
    watchDom();

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
